import { InstructionalFeatureCheckbox } from "./InstructionalFeatureCheckbox";

export { InstructionalFeatureCheckbox };
